<form action="./content-form.html" method="post" class="form">
  @if (showBanner) {
    <div class="alert alert-warning" role="banner" [innerHTML]="bannerContent"></div>
  }

  <p>Use this form to notify us if you intend to undertake clearing
  activities under an accepted development vegetation clearing code. </p>
  <div class="alert alert-info" role="alert">
    <p>Note: Not all clearing activities can be notified online. You
      will need to submit a hard-copy notification if you are clearing on a road or in
      a boundary watercourse under the codes for managing weeds, clearing for
      infrastructure, clearing for an extractive industry or necessary environmental
    clearing.</p>
  </div>
  <p>Read more about <a
    href="https://www.qld.gov.au/environment/land/management/vegetation/clearing-approvals/codes/choose"
  class="external-link" rel="nofollow">accepted development vegetation clearing codes</a><small
  class="print-link-url">
(https://www.qld.gov.au/environment/land/management/vegetation/clearing-approvals/codes/choose)</small>.</p>

<p>Before commencing the notification form, we recommend you:</p>
<ul>
  <li>Obtain a <a href="https://www.qld.gov.au/environment/land/vegetation/map-request/" class="external-link"
  rel="nofollow">vegetation management report</a><small class="print-link-url"> (
https://www.qld.gov.au/environment/land/vegetation/map-request/ )</small>
for your lot; and
</li>
<li>
  Check the relevant agencies listed in the Other Relevant Legislation section of the <a href="https://www.qld.gov.au/environment/land/management/vegetation/clearing-approvals/codes/choose">applicable
code</a>, to determine whether your proposed clearing activity is allowable under other local, state and federal
laws.
</li>
</ul>


<p>You will also need to know:</p>
<ul>
  <li>The location of the clearing area (or provide a map)</li>
  <li>Area (in hectares) intended to be cleared</li>
  <li>Regional ecosystems in the area to be cleared</li>
</ul>

<p>We will contact you by email advising your notification
reference number and confirming that your notification has been lodged.</p>

<li class="footer">
  <ul class="actions">
    @if (!healthCheckSuccessStatus) {
      <div class="alert alert-warning" role="alert">
        <p>Apologies, there was an issue in loading this page. Please hit your browser refresh button.</p>
      </div>
    }
    <br/>
    <li>
      <em> <input class="qg-btn btn-primary" type="submit" (click)="next()" value="Get started" /> </em>
    </li>
    <li>
      <h2>Privacy</h2>
      <p>The Department of Natural Resources and Mines, Manufacturing and Regional and Rural Development is collecting the information
        submitted on this form to meet legislative requirements under the <em>Vegetation
      Management Act 1999</em>. We will publish public location data and the
      purpose of the notified activity in a public register. Your personal information
      will not be disclosed to any other parties unless authorised or required by law.
    </p>
    <p>Read more about <a href="https://www.resources.qld.gov.au/home/legal/privacy" target="_blank"
    class="external-link" rel="nofollow">our privacy policy</a><small class="print-link-url"> (
  https://www.resources.qld.gov.au/home/legal/privacy )</small>.</p>
  <p style="text-align: right;"><small style="font-size:7px">v{{appinfo}}</small></p>
</li>
</ul>
</li>
</form>
